import React, {Component} from 'react';
import ReactDOM from "react-dom";

/*
* Authentication
*/
import Alt from 'alt';
import history from '../../history';
import axios from 'axios';
import AuthActions from '../../actions/AuthActions';
import AuthStore from '../../stores/AuthStore';
import routes from '../../routes';

import Constants from '../Constants';
import { Router, Route, Link } from 'react-router-dom'

import ReactTooltip from 'react-tooltip'

import {
    Badge,
    Row,
    Col,
    Button,
    Label,
    Table,
    Progress,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Input
} from "reactstrap";

class ExamList extends Component {
    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.updateToValue = this.updateToValue.bind(this);
        this.updateContentValue = this.updateContentValue.bind(this);

        this.state = {
            now: new Date(),
            modal: false,
            to: "",
            content: "",
            examToSend: null
        }
    }

    componentDidUpdate(){
        ReactTooltip.rebuild();
    }

    componentDidMount() {
      this.refreshTimeThread = setInterval(function(){ this.setState({now: new Date()});  }.bind(this), 1000);
    }
    componentWillUnmount() {
      clearInterval(this.refreshTimeThread);
    }

    downloadPDF(examId, publicId){

      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/exam/report/'+examId
      })
      .then(response => {
          var fileDownload = require('react-file-download');
          console.log(response);
          var base64js = require('base64-js');
          fileDownload(base64js.toByteArray(response.data), publicId+'.pdf', "application/pdf;base64");
      });
    }

    toggleModal(exam) {
      this.setState({
        modal: !this.state.modal,
        examToSend: exam
      });
    }

    sendExamByEmail(examId, to, content){
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/exam/email',
          data: {'examId': examId, 'to': to, 'content': content}
      })
      .then(response => {
        this.setState({
          to: "",
          content: ""
        });
      });

      this.toggleModal();
    }

    updateToValue(evt) {
      let to = evt.target.value.split(',');
      this.setState({
        'to': to
      });
    }

    updateContentValue(evt) {
      this.setState({
        'content': evt.target.value
      });
    }

    getReportLimit(exam){
        var clientReportLimit = 0;

        if(exam.client.reportLimit > 0){
            clientReportLimit = exam.client.reportLimit;
        }else{
            if(exam.client.priority == "PRIORITY_LOW") clientReportLimit = 1440;
            if(exam.client.priority == "PRIORITY_NORMAL") clientReportLimit = 60;
            if(exam.client.priority == "PRIORITY_HIGH") clientReportLimit = 10;
            if(exam.client.priority == "PRIORITY_URGENCY") clientReportLimit = 5;
        }

        if(exam.urgent && clientReportLimit > 10){
            clientReportLimit = 10;
        }

        return clientReportLimit;
    }

    pad(a,b){return(1e15+a+"").slice(-b)}

    render() {
    if(this.props.examList == null) return null;

    var rows = [];
    this.props.examList.exams.forEach(function(examObj) {
        let exam = examObj;
        //icon
        var icon = null;

        if(exam.client.priority == 'PRIORITY_LOW') icon = <i className="fa fa-circle fa-2x text-default" data-tip="Prioridade Eletiva"></i>
        if(exam.client.priority == 'PRIORITY_NORMAL') icon = <i className="fa fa-circle fa-2x text-info" data-tip="Prioridade Normal"></i>
        if(exam.client.priority == 'PRIORITY_HIGH') icon = <i className="fa fa-circle fa-2x text-warning" data-tip="Prioridade Alta"></i>
        if(exam.client.priority == 'PRIORITY_URGENCY') icon = <i className="fa fa-circle fa-2x text-danger" data-tip="Urgência"></i>

        if(((exam.dtReceived - exam.patient.dtBirthDate)  / 60 / 60 / 24 / 30 / 12 / 1000) < 12)
            icon = <span className="fa-stack fa-lg">
                        {icon}
                        <i className="fa fa-child fa-stack-1x fa-inverse"></i>
                    </span>

        let date = new Date(exam.dtReceived);
        let dtReport = new Date(exam.dtReportEnd);

        rows.push(
        <tr key={exam.id} className={exam.urgent ? "bg-danger" : ""}>
            <td className="text-center">
                {icon}
            </td>
            <td className="text-left">
                {exam.publicId}
            </td>
            <td className="text-left">
                  {this.pad(date.getHours(), 2)}:{this.pad(date.getMinutes(), 2)}:{this.pad(date.getSeconds(), 2)}
                  <small>
                  {'\u00A0'}
                  {this.pad(date.getDate(), 2)}/{this.pad(date.getMonth()+1, 2)}/{date.getFullYear()}
                  </small>
            </td>
            {this.props.showDtReport ?
              <td className="text-left">
                    {this.pad(dtReport.getHours(), 2)}:{this.pad(dtReport.getMinutes(), 2)}:{this.pad(dtReport.getSeconds(), 2)}
                    <small>
                    {'\u00A0'}
                    {this.pad(dtReport.getDate(), 2)}/{this.pad(dtReport.getMonth()+1, 2)}/{dtReport.getFullYear()}
                    </small>
              </td>
              : null
            }
            <td>
                <div>{exam.patient.firstname} {exam.patient.lastname}</div>
                <div className="small text-muted">
                    {exam.client.name}
                </div>
            </td>
            <td className="text-left">
                <div>
                    {exam.status == 'EXAM_STATUS_REPORTED' ? <Badge color="success">Laudado</Badge> : ''}
                    {exam.status == 'EXAM_STATUS_PREREPORTED' ? <Badge color="warning">Pré Laudado</Badge> : ''}
                    {exam.status == 'EXAM_STATUS_RECEIVED' ? <Badge color="info">Recebido</Badge> : ''}
                    {exam.status == 'EXAM_STATUS_SENT_TO_REPORT' ? <Badge color="info">Aguardando Laudo</Badge> : ''}
                    {exam.status == 'EXAM_STATUS_WAITING_REPORT' ? <Badge color="warning">Em Laudo</Badge> : ''}
                </div>
            </td>
            <td>
                <div>{exam.doctor != null ? exam.doctor.name : ""}</div>
                <div className="small text-muted">
                    <span>{exam.doctor != null ? exam.doctor.crm : ""}</span>
                </div>
            </td>
            {exam.status == 'EXAM_STATUS_REPORTED' ?
            <td>
                <div className="clearfix">
                    <div className="float-left">
                        <strong>{Math.round( (((exam.dtReportEnd - exam.dtReceived) / 1000 / 60  ) * 100 ) /  this.getReportLimit(exam))}%</strong>
                    </div>
                    <div className="float-right">
                        <small className="text-muted">{Number(((exam.dtReportEnd - exam.dtReceived) / 1000 / 60  )).toFixed(2)} mins</small>
                    </div>
                </div>
                <Progress className="progress-xs" color={((((exam.dtReportEnd - exam.dtReceived) / 1000 / 60  ) * 100 ) /  this.getReportLimit(exam)) <=  100 ? "success" : "warning"} value={((((exam.dtReportEnd - exam.dtReceived) / 1000 / 60  ) * 100 ) /  this.getReportLimit(exam))}/>
            </td>
            : null}
            {exam.status != 'EXAM_STATUS_REPORTED' ?
            <td>
                <div className="clearfix">
                    <div className="float-left">
                        <strong>{Math.round( (((this.state.now - exam.dtReceived) / 1000 / 60  ) * 100 ) /  this.getReportLimit(exam))}%</strong>
                    </div>
                    <div className="float-right">
                        <small className="text-muted">{(this.getReportLimit(exam) - ((this.state.now - exam.dtReceived) / 1000 / 60 )).toFixed(0)} mins restantes</small>
                    </div>
                </div>
                <Progress className="progress-xs" color={(((this.state.now - exam.dtReceived) / 1000 / 60  ) * 100 ) /  this.getReportLimit(exam) <=  100 ? "success" : "warning"} value={((((this.state.now - exam.dtReceived) / 1000 / 60  ) * 100 ) /  this.getReportLimit(exam))}/>
            </td>
            : null}
            <td>
                {exam.status != 'EXAM_STATUS_REPORTED' && !this.props.hideReportLink ?
                  <Link to={"/examViewer/"+exam.id}>
                      <Button color="primary" className="margin"><i className="fa fa-heartbeat"></i></Button>
                  </Link>
                  : ""
                }
                {!this.props.hideViewLink ?
                  <Link to={"/examViewer/"+exam.id}>
                      <Button color="primary" className="margin"><i className="fa fa-search"></i></Button>
                  </Link>
                  : ""
                }
                <Button color="warning" className="margin" onClick={() => { this.downloadPDF(exam.id, exam.publicId); }}><i className="fa fa-file-pdf-o"></i></Button>
                <Button color="success" className="margin" onClick={() => {this.toggleModal(exam)}}><i className="fa fa-envelope"></i></Button>
            </td>
        </tr>
        );
    }.bind(this));

    return (
        <div>
        <Table hover responsive className="table-outline mb-0 d-sm-table">
            <thead className="thead-default">
                <tr>
                    <th></th>
                    <th>ID</th>
                    <th>Recepção</th>
                    {this.props.showDtReport ?
                    <th>Laudo</th>
                      : null
                    }
                    <th>Paciente</th>
                    <th>Status</th>
                    <th>Médico</th>
                    <th>Tempo de Laudo</th>
                    <th><i className="fa fa-cog"></i></th>
                </tr>
            </thead>
            <tbody>
                {rows.length > 0 ? rows : null}
            </tbody>
        </Table>

        <Modal isOpen={this.state.modal} toggle={this.toggleModal} className="info">
          <ModalHeader toggle={this.toggleModal}>Enviar Exame {this.state.examToSend == null ? "" : this.state.examToSend.publicId} por email</ModalHeader>
            <ModalBody>
            <Row>
                <Col xs="12" md="12">
                    <Label htmlFor="to">Destinarários</Label>
                    <Input type="text" id="to" value={this.state.to} onChange={this.updateToValue}/>
                </Col>
                <Col xs="12" md="12">
                    <Label htmlFor="content">Conteúdo</Label>
                    <Input type="textarea" id="content" value={this.state.content} onChange={this.updateContentValue}/>
                </Col>
              </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={() => this.sendExamByEmail(this.state.examToSend == null ? "000" : this.state.examToSend.id, this.state.to, this.state.content)}>Enviar</Button>{' '}
            <Button color="danger" onClick={this.toggleModal}>Cancelar</Button>
          </ModalFooter>
        </Modal>

        <ReactTooltip />
    </div>
    )
  }
}

export default ExamList;



// WEBPACK FOOTER //
// ./src/components/ExamList/ExamList.js